// Helper functions to get date strings.
export function today() {
  return new Date().toISOString().split("T")[0];
}

export function tomorrow() {
  let tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);

  return tomorrow.toISOString().split("T")[0];
}

export function prevDate(date) {
  let prevDay = new Date(date);
  prevDay.setDate(prevDay.getDate() - 1);
  const offset = prevDay.getTimezoneOffset();
  prevDay = new Date(prevDay.getTime() - offset * 60 * 1000);

  return prevDay.toISOString().split("T")[0];
}

export function nextDate(date) {
  let nextDay = new Date(date);
  nextDay.setDate(nextDay.getDate() + 1);
  const offset = nextDay.getTimezoneOffset();
  nextDay = new Date(nextDay.getTime() - offset * 60 * 1000);

  return nextDay.toISOString().split("T")[0];
}

export function monthFromDateString(date) {
  return date.slice(0, 7);
}

export function nextMonth(date) {
  let newDate = new Date(date);
  newDate.setMonth(newDate.getMonth() + 1);
  const offset = newDate.getTimezoneOffset();
  newDate = new Date(newDate.getTime() - offset * 60 * 1000);

  return newDate.toISOString().split("T")[0];
}

export function nextWeekend() {
  let date = new Date();
  date.setDate(date.getDate() + ((5 - 1 - date.getDay() + 7) % 7) + 1);

  return date.toISOString().split("T")[0];
}

export function nextMonday() {
  let date = new Date();
  date.setDate(date.getDate() + ((1 + 7 - date.getDay()) % 7 || 7));

  return date.toISOString().split("T")[0];
}

export function getWeek(date) {
  let weekArray = [date];
  for (let i = 0; i < 6; i++) {
    weekArray.push(nextDate(weekArray[i]));
  }
  return weekArray;
}

export function getCurrentDate() {
  return new Date().toISOString().split("T")[0];
}

export function getLastDayOfMonth() {
  return new Date(new Date().getFullYear(), new Date().getMonth() + 1, 1)
    .toISOString()
    .split("T")[0];
}
